module.exports = __webpack_public_path__ + "static/3-3c7586a4ca7ec32732be7e4931104130.jpg";